import { isEmpty, size } from 'lodash/fp';

import CalloutSection from '../../../../components/sections/callout-section';
import FeaturesSection from '../../../../components/sections/features-section';

type ValuePropositionsProps = {
  tiles?: any[];
};

// Note: this component has been moved to ahm-ui, ahm-sales cleanup impending (FW-1251)
const ValuePropositions = (props: ValuePropositionsProps) => {
  const { tiles } = props;
  if (!tiles || isEmpty(tiles)) {
    return null;
  }

  if (size(tiles) > 1) {
    // @ts-expect-error - Automatic, Please fix when editing this file
    return <FeaturesSection {...props} withBorder />;
  }

  return <CalloutSection {...tiles[0]} withBorder />;
};

export default ValuePropositions;
